// extracted by mini-css-extract-plugin
export var info = "info-module--info--3uWMa";
export var info__wrap = "info-module--info__wrap--18f-j";
export var info__section = "info-module--info__section--dGoUj";
export var info__section__image = "info-module--info__section__image--nzmRM";
export var info__section__image__bg = "info-module--info__section__image__bg--RfK91";